import { z } from 'zod';
import { actorRefSchema, roleCodeSchema, roleRefSchema, } from '#src/access/roles.contract.js';
import { pageOf } from '#src/common/pagination.contract.js';
export const USER_NAME_MAX_LENGTH = 255;
export const EMAIL_MAX_LENGTH = 320;
/** Pessoa cadastrada no app, como a gestão de acessos a vê. */
export const accessUserSchema = z.strictObject({
    id: z.uuid(),
    name: z.string(),
    email: z.string(),
    /** Perfis da pessoa, em ordem de nome. */
    roles: z.array(roleRefSchema),
    active: z.boolean(),
    /** Ligada à conta do Entra ID (já entrou pelo Teams ou veio do diretório). */
    linkedToEntra: z.boolean(),
    /** Último uso do app; nulo para quem foi cadastrado e ainda não entrou. */
    lastSeenAt: z.iso.datetime({ offset: true }).nullable(),
    createdAt: z.iso.datetime({ offset: true }),
});
export const accessUserPageSchema = pageOf(accessUserSchema);
export const userEventActionSchema = z.enum([
    'granted',
    'role-added',
    'role-removed',
    'deactivated',
    'reactivated',
]);
/** Uma mudança elementar; `role` só nas de perfil. */
export const userEventSchema = z.strictObject({
    action: userEventActionSchema,
    role: roleRefSchema.nullable(),
});
/** Mudanças feitas juntas, pela mesma pessoa. */
export const accessHistoryEntrySchema = z.strictObject({
    at: z.iso.datetime({ offset: true }),
    actor: actorRefSchema,
    events: z.array(userEventSchema),
});
export const accessUserDetailSchema = z.strictObject({
    user: accessUserSchema,
    history: z.array(accessHistoryEntrySchema),
});
/**
 * Dá acesso a alguém que ainda não está no app. `entraObjectId` vem da busca
 * no diretório e liga o cadastro à conta do Entra ID desde já.
 */
export const grantAccessRequestSchema = z.strictObject({
    email: z
        .string()
        .trim()
        .toLowerCase()
        .max(EMAIL_MAX_LENGTH)
        .regex(/^[^@\s]+@[^@\s]+$/),
    name: z.string().trim().min(1).max(USER_NAME_MAX_LENGTH),
    entraObjectId: z.uuid().optional(),
    roles: z.array(roleCodeSchema).min(1, 'Escolha ao menos um perfil'),
});
export const setRolesRequestSchema = z.strictObject({
    roles: z.array(roleCodeSchema),
});
export const setActiveRequestSchema = z.strictObject({
    active: z.boolean(),
});
/** Pessoa do diretório da empresa (Entra ID), para dar acesso. */
export const directoryPersonSchema = z.strictObject({
    /** `id` do Entra ID. */
    id: z.uuid(),
    name: z.string(),
    email: z.string(),
    /** Já está cadastrada no app. */
    alreadyUser: z.boolean(),
});
export const directoryPersonListSchema = z.strictObject({
    items: z.array(directoryPersonSchema),
});
export const DIRECTORY_MIN_QUERY = 2;
export const directoryQuerySchema = z.strictObject({
    q: z.string().trim().min(DIRECTORY_MIN_QUERY).max(100),
});
/** Situação do app no Teams pessoal da pessoa. */
export const teamsAppStatusSchema = z.strictObject({
    state: z.enum(['installed', 'not-installed', 'unknown']),
    /** Por que não dá para saber ou instalar, quando for o caso. */
    detail: z.string().nullable(),
});
//# sourceMappingURL=users.contract.js.map